webpackJsonp([36575300847545],{

/***/ 962:
/***/ (function(module, exports) {

	module.exports = {"title":"Biometrics","headline":"State of the art eye tracking!","p1":"Our goal is to simulate private lessons with a top chess coach. That means that we need to be able to adapt the training to the needs of each individual user. In order to achieve this we both offer a state of the art comprehensive chess exercise program and also biometrics.","p2":"With biometrics we aim to give the computer human like capabilities to sense how the user is feeling and what can be improved in his or her thought process. Our goal is to provide the right training and use the training time as efficiently as possible.","p3":"Eye tracking (optional) enables us to measure gaze - where on the screen one is looking - and also pupil dilation. Our software can be used with a Tobii 4C eye tracker.","p4":"Facial expressions analysis (optional) through a webcam enables us to understand better how our user is feeling with the goal to adapt the training to the daily form of the user. We work with an international team of University professors on improving our biometrics.","p5":"Our goal is to help you reach the best possible mental state of learning and enjoying our personalized training!","p6":"Become the best version of yourself with personalized training!","download":{"line1":"Download OcuChess!","line2":"Our most advanced learning platform"}}

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(9);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var content = props.content,
	      data = props.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.img.childImageSharp.sizes })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      { className: 'py-4' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'text-color-title' },
	        content.title
	      ),
	      _react2.default.createElement(
	        'h4',
	        { className: 'text-color-subtitle' },
	        content.headline
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p1
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p2
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p3
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p4
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p5
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p6
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/', className: 'btn-lg btn btn-success text-center' },
	          content.download.line1,
	          ' ',
	          _react2.default.createElement('br', null),
	          content.download.line2
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _biometricsLayout = __webpack_require__(178);
	
	var _biometricsLayout2 = _interopRequireDefault(_biometricsLayout);
	
	var _biometrics = __webpack_require__(962);
	
	var _biometrics2 = _interopRequireDefault(_biometrics);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Scichess | Biometrics'
	      )
	    ),
	    _react2.default.createElement(_biometricsLayout2.default, _extends({ content: _biometrics2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-methods-biometrics-index-en-js-8c1453eebdb8f13778e8.js